import React, { useState } from 'react';
import { useDynamicMenu, useAlgolia } from '../../hooks';
import { CORPORATE_MENU } from '.';
import HeaderTop from './HeaderTop';
import HeaderBottom from './HeaderBottom';
import SearchContainer from './SearchContainer';
import { MobileMenu } from './MobileMenu';
import mapNavigationLinks from './utils/mapNavigationLinks';
import { useBuilderNavigation } from '../../hooks/useBuilderNavigation';
import { useCountdownHeaderHeight } from '../../hooks/useCountdownHeaderHeight';

import './Header.css';

export function Header({ siteData, showCountdown }) {
    const [isOpen, setIsOpen] = useState(false);
    useCountdownHeaderHeight(showCountdown);

    const { navigationLinks } = useBuilderNavigation();

    const navLinks =
        navigationLinks && navigationLinks.length > 0 ? mapNavigationLinks(navigationLinks) : CORPORATE_MENU;

    // Filter out "Clients" dropdown for mobile (case-insensitive)
    const mobileNavLinks = navLinks.filter((item) => item.link?.toLowerCase() !== 'clients');

    const dynamicMenu = useDynamicMenu(siteData, navLinks);
    const mobileDynamicMenu = useDynamicMenu(siteData, mobileNavLinks);

    // Algolia Search
    const [searchView, setSearchView] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const searchHandler = (e) => setSearchInput(e.target.value);
    const hits = useAlgolia(searchInput, siteData.milanStores);

    return (
        <header>
            <HeaderTop {...{ isOpen, setIsOpen, showCountdown }} />
            <HeaderBottom menu={dynamicMenu} {...{ searchView, setSearchView }} showCountdown={showCountdown} />
            <SearchContainer {...{ hits, searchInput, searchView, setSearchView, searchHandler }} />
            <MobileMenu
                {...{ searchInput, hits, searchHandler, isOpen }}
                menu={mobileDynamicMenu}
                closeMenu={() => setIsOpen(false)}
            />
        </header>
    );
}

export default Header;
